/**
 * WD-3 — Discard upload confirm.
 * Abandoning a resumable upload throws away the bytes already sent and the
 * resume fingerprint, so it is worth a confirmation (US-A04).
 */
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'
import { formatBytes } from '@/lib/upload-manager'

export interface DiscardUploadDialogProps {
  open: boolean
  fileName: string
  bytesSent: number
  onConfirm: () => Promise<void> | void
  onCancel: () => void
}

export const DiscardUploadDialog = ({
  open,
  fileName,
  bytesSent,
  onConfirm,
  onCancel,
}: DiscardUploadDialogProps) => {
  const translate = useAdminTranslate()

  return (
    <ConfirmDialog
      open={open}
      danger
      title={translate('admin.dialogs.discardUpload.title')}
      description={translate('admin.dialogs.discardUpload.description', {
        size: formatBytes(bytesSent),
        file: fileName,
      })}
      confirmLabel={translate('admin.dialogs.discardUpload.confirm')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
